const initialState = [
  {
    userLogin: [],
  },
];

const userLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_LOGIN":
      return {
        ...state,
        userLogin: action.payload,
      };
    default:
      return state;
  }
};

export default userLoginReducer;
